import React from "react";
import {toAbsoluteUrl} from "../../_metronic/helpers";
import {getBrandImage} from "../pages/generic/OEMList";
import {useThemeMode, systemMode} from "../../_metronic/partials/layout/theme-mode/ThemeModeProvider";

// Inner component that can use hooks
function BrandImageContent({brandName, imageUrl, size, imgSize}) {
    const {mode} = useThemeMode();
    const isDarkMode = mode === 'dark' || (mode === 'system' && systemMode === 'dark');

    const containerStyle = {
        borderRadius: '8px',
        padding: '8px',
        transition: 'all 0.2s ease',
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...(isDarkMode ? {
            backgroundColor: '#1e1e2d',
            border: '1px solid #2b2b40',
            boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
        } : {
            backgroundColor: '#f5f8fa',
            border: '1px solid #e4e6ef',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        })
    };

    return (
        <div className="d-flex align-items-center">
            <div
                className={`symbol symbol-${size} me-4`}
                style={containerStyle}
            >
                <img
                    style={{
                        height: imgSize,
                        width: imgSize,
                        objectFit: 'contain',
                        display: 'block'
                    }}
                    src={imageUrl}
                    className=""
                    alt={brandName}
                    loading="lazy"
                />
            </div>
            <div className="d-flex justify-content-start flex-column">
                <span className="text-gray-900 fw-bolder fs-6 mb-1">
                    {brandName || 'Unknown'}
                </span>
                <span className="text-gray-500 fw-semibold fs-7">
                    Brand
                </span>
            </div>
        </div>
    );
}

export function BrandImageFormatter(cellContent, row, rowIndex, formatExtraData) {
    const brandName = cellContent || '';
    const imageName = getBrandImage(brandName);
    const imageUrl = toAbsoluteUrl(`/media/car/${imageName}`);

    const size = formatExtraData?.size || '50px';
    const imgSize = formatExtraData?.imgSize || '45px';

    return <BrandImageContent brandName={brandName} imageUrl={imageUrl} size={size} imgSize={imgSize} />;
}
